<template>
  <v-app>
    <v-card  v-if="systemData" class="noMarginCard mainContainer" tile height="100%">
      <v-app-bar color="primary accent-4" dark>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <v-toolbar-title>MyASD {{ currentRouteName }} </v-toolbar-title>
        <v-spacer v-if="dateFilter"></v-spacer>
        <my-datepicker
          :dense="true"
          :labelLeft="true"
          v-if="dateFilter"
          v-model="dateInz"
          label="data inizio"
          required="true"
        />
        <my-datepicker
          :dense="true"
          :labelLeft="true"
          v-if="dateFilter"
          v-model="dateEnd"
          label="data fine"
          required="true"
        />
        <v-spacer></v-spacer>
        <div v-if="systemData && systemData.remoteFrontendStatus">
          {{ systemData.remoteFrontendUrl }} <v-icon>mdi-vuetify</v-icon>
        </div>
        <v-btn @click="refresh" class="mx-2" fab small color="secondary">
          <v-icon dark> mdi-refresh </v-icon>
        </v-btn>
        <v-btn @click="logout" class="mx-2" fab small color="error">
          <v-icon dark> mdi-logout </v-icon>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" absolute bottom temporary>
        <v-list nav dense>
          <v-list-item-group
            v-model="group"
            active-class="primary--text text--accent-4"
          >
            <v-list-item>
              <v-list-item-title @click="$router.push('/mgmt/console')"
                ><v-icon>mdi-desktop-classic</v-icon>Console</v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="$router.push('/mgmt/firewall')"
                ><v-icon>mdi-shield-lock-outline</v-icon
                >Firewall</v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title @click="$router.push('/mgmt/translations')"
                ><v-icon>mdi-translate</v-icon>Gestione
                traduzioni</v-list-item-title
              >
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <router-view :dateInz="dateInz" :dateEnd="dateEnd" ref="childComponent"
    /></v-card>

    <v-card v-else class="noMarginCard mainContainer" tile height="100%">
      <router-view ref="childComponent"></router-view>
    </v-card>
  </v-app>
</template>

<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  components: { MyDatepicker },
  name: "mgmt-view",
  props: {},
  data: () => ({
    drawer: false,
    dateFilter: false,
    group: null,
    systemData: null,
    dateEnd: new Date(),
    dateInz: new Date(new Date() - 7 * 24 * 60 * 60 * 1000),
  }),
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
    $route(to, from) {
      this.dateFilter = false;
      if (this.$route.path === "/mgmt/firewall") this.dateFilter = true;
    },
  },
  methods: {
    refresh: function () {
      this.$globalHandler.refresh.flag = true;
    },
    logout: function () {
      localStorage.removeItem("mgmtAuthToken");
      this.$router.push("/mgmt/login");
      window.location.reload();
    },
  },
  mounted() {
    this.dateFilter = false;
    if (this.$route.path === "/mgmt/firewall") this.dateFilter = true;
    this.systemData = window.systemData;
  },
};
</script>

<style type="text/css">
.mainContainer {
  margin: 0px !important;
  padding: 0px !important;
  border-radius: 0px !important;
  background-image: url("./../../../public/error-image.jpg") !important;
  background-size: cover !important;
}
.gChart table {
  margin: auto !important;
}
.chartLabel {
  text-align: center;
}
.sysInfo td {
  font-size: 12px !important;
}

.noMarginCard {
  margin-top: 0px !important;
  height: 100%;
  overflow: auto !important;
}
</style>